export const blockedInstallmentPaymentTerm = '401'
